import { Button, Card, Col, Container, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import "./Home.css";
import { FaGear, FaPlus } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { useSpinner } from "../../Utilities/SpinnerContext";
import { useBreadcrumbs } from "../../Utilities/Breadscrumb/BreadcrumbContext";
import { useShelveData } from "../../hooks/useShelveData";
import ToastrNotifi from "../../Utilities/ToastrNotifi";
import GlobalSpinner from "../../Utilities/GlobleSpinner";
const beURL = localStorage.getItem('BeURL');


function Home() {
    const navigate = useNavigate();
    // const [shelveList, setShelves] = useState([]);
    const beURL = localStorage.getItem('BeURL');
    const { showSpinner, hideSpinner } = useSpinner();
    const [loading, setLoading] = useState(true);

    function createShelf() {
        navigate('/create/shelve');
    }

    function shelveContents(shelve_slug, shelve_name, shelve_id, shelve_disc) {
        navigate(`/${shelve_id}/${shelve_slug}`);
    }

    const { addBreadcrumb, clearBreadcrumbs } = useBreadcrumbs();
    const location = useLocation();

    useEffect(() => {
        clearBreadcrumbs(); // Clear existing breadcrumbs
        addBreadcrumb('Home', location.pathname); // Add current breadcrumb
        return () => clearBreadcrumbs(); // Cleanup when component unmounts
      }, [addBreadcrumb, clearBreadcrumbs]);


    const {data:shelveList, isError:isShelveError, error:shelveError, isLoading:isShelveLoading, isSuccess:isShelveSuccess}= useShelveData();
   


    if(isShelveError){
        ToastrNotifi.errorToast(shelveError.message);
    }

      if(isShelveLoading){
        return <GlobalSpinner/>
    }
    return (
        <><Container fluid>
            <Row>
                <Col sm={12} md={12} className="py-2 my-2" >
                    <Card className="border-b-none">
                        <Card.Header className="border-b-none d-flex justify-content-between align-items-center" >
                            <div className="h4">
                                Shelves
                            </div>

                            <div>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="tooltip-top" className="tooltip-z">Create New Shelve</Tooltip>}
                                >
                                    <Button variant="outline-secondary" onClick={createShelf}><FaPlus size={20}></FaPlus></Button>
                                </OverlayTrigger></div>
                        </Card.Header>
                    </Card>
                </Col>

            </Row>
            <Row>
                {shelveList?.length == 0 ? (
                    <Col sm={12} md={12} >
                        <h3 className="text-center text-secondary">There is No Shelves, Please Create one </h3>
                    </Col>
                ) : (
                    shelveList?.map((shelve) => {
                        const handleImageLoad = () => { //for loading image ui
                            setLoading(false);
                        };

                        return (
                            <Col sm={6} md={3} key={shelve.id}>
                                <Card className="card-custom mb-2" onClick={() => shelveContents(shelve.slug, shelve.name, shelve.id, shelve.description)}>
                                    <Card.Body>
                                        <div className="p-2 image-container">
                                            {loading && (
                                                <div className="d-flex justify-content-center align-items-center" style={{ height: '150px' }}>
                                                    <Spinner animation="border" />
                                                </div>
                                            )}
                                            <img
                                                src={`${beURL}${shelve.image_path}`}
                                                className={`img-fluid image-contain ${loading ? 'd-none' : ''}`}
                                                alt="shelve"
                                                onLoad={handleImageLoad}
                                            />
                                        </div>
                                    </Card.Body>
                                    <Card.Header>
                                        <div className="text-center h5">{shelve.name}</div>
                                    </Card.Header>
                                </Card>
                            </Col>
                        );
                    })

                )}

            </Row>
            </Container>
        </>


    );
}

export default Home;